import './App.css';
import MainPage from './components/MainPage';


function App() {
  return (
    // <div style={{ textAlign: 'center', marginTop: '20px'}}>
    //   <h2> Graph Coloring </h2>
    //   <GraphVisualizer />
    // </div>
    <MainPage/>
  );
}


export default App;




